import { commissionGroupApi } from "api/TenantSlug/CommissionGroup/api.ts";

export function composeGetCommissionGroupQueryOptions(commissionGroupId: string, request?: unknown) {
    return {
        queryKey: ["getCommissionGroup", commissionGroupId, request],
        queryFn: () => commissionGroupApi.show(commissionGroupId, request),
    };
}

export function getCommissionGroupQueryOptions(commissionGroupId: string, request?: unknown) {
    return {
        ...composeGetCommissionGroupQueryOptions(commissionGroupId, request),
        suspense: true,
    };
}
